export const canManageRegions=(role?:string)=>role==='DIRECTOR'||role==='SYSTEM_ADMIN';
